<template>
  <span :for="id" class="btn-select">
    <select class="selectbox"
            :name="name"
            :id="id"
            :value='value'
            @change="updateValue"
            @input="sendInputEvent($event)"
            @focus="onFocus($event)"
            @blur="onBlur($event)"
            @click="sendClickEvent($event)"
            @mousedown="sendMousedownEvent($event)"
            @mouseover="sendMouseoverEvent($event)"
            @mouseout="sendMouseoutEvent($event)"
            @keydown="sendKeydownEvent($event)"
            @keyup="sendKeyupEvent($event)"
    ><slot></slot></select>
  </span>
</template>

<script>
import FormEvent from '../../components/mixin/FormEvent'
export default {
  name: 'btn-select',
  mixins: [FormEvent],
  props: ['name', 'id', 'value', 'trackingName'],
  methods: {
    updateValue (e) {
      this.sendChangeEvent(e)
      let value = e.target.value ? e.target.value : null
      this.$emit('input', value)
      this.$emit('checked', value)
    },
    onFocus (e) {
      this.sendFocusEvent(e)
      this.$emit('focus', e)
    },
    onBlur (e) {
      this.sendBlurEvent(e)
      this.$emit('blur', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.btn-select {
  position: relative;
  display: inline-block;
  color: $black;
  >select{
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0;
    margin: 0;
    background: $white;
    position: relative;
    padding: 7px 40px 7px 10px;
    border: 1px solid $secondary;
    border-radius: 0;
    font-size: 16px;
    line-height: 24px;
    &.selectbox {
      width: 100%;
      max-width: 360px;
    }
  }
  >select::-ms-expand {
    display: none;
  }
}
.btn-select::before{
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  background: $white;
  height: 100%;
  width: 30px;
}
.btn-select::after{
  content: '';
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 9px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 6px 0 6px;
  border-color: $primary transparent transparent transparent;
}

</style>



// WEBPACK FOOTER //
// src/components/button/BtnSelect.vue